import { StyleConfigs } from "../types"

export const styleConfigs: StyleConfigs = {
  backgroundColor: {
    tokens: ["backgroundColors", "colors"],
    tokensOnly: true,
  },
  borderColor: {
    tokens: ["borderColors"],
    tokensOnly: true,
  },
  borderBottomColor: {
    tokens: ["borderColors"],
    tokensOnly: true,
  },
  borderLeftColor: {
    tokens: ["borderColors"],
    tokensOnly: true,
  },
  borderRightColor: {
    tokens: ["borderColors"],
    tokensOnly: true,
  },
  borderTopColor: {
    tokens: ["borderColors"],
    tokensOnly: true,
  },
  borderRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  borderBottomLeftRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  borderBottomRightRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  borderTopLeftRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  borderTopRightRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  borderWidth: {
    tokens: ["borderWidths"],
    tokensOnly: true,
  },
  borderBottomWidth: {
    tokens: ["borderWidths"],
    tokensOnly: true,
  },
  borderLeftWidth: {
    tokens: ["borderWidths"],
    tokensOnly: true,
  },
  borderRightWidth: {
    tokens: ["borderWidths"],
    tokensOnly: true,
  },
  borderTopWidth: {
    tokens: ["borderWidths"],
    tokensOnly: true,
  },
  fill: {
    tokens: ["colors"],
    tokensOnly: false,
  },
  stroke: {
    tokens: ["colors"],
    tokensOnly: true,
  },
  flexBasis: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  width: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  height: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  minWidth: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  minHeight: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  maxWidth: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  maxHeight: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  outlineColor: {
    tokens: ["colors"],
    tokensOnly: true,
  },
  top: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  right: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  bottom: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  left: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  shadowColor: {
    tokens: ["colors"],
    tokensOnly: true,
  },
  shadowRadius: {
    tokens: ["borderRadii"],
    tokensOnly: true,
  },
  margin: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginTop: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginRight: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginBottom: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginLeft: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginVertical: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  marginHorizontal: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  padding: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingTop: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingRight: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingBottom: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingLeft: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingVertical: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  paddingHorizontal: {
    tokens: ["spaces"],
    tokensOnly: false,
  },
  color: {
    tokens: ["textColors"],
    tokensOnly: true,
  },
  fontSize: {
    tokens: ["fontSizes"],
    tokensOnly: true,
  },
  fontWeight: {
    tokens: ["fontWeights"],
    tokensOnly: true,
  },
  lineHeight: {
    tokens: ["lineHeights"],
    tokensOnly: true,
  },
}
